module.exports = __webpack_public_path__ + "img/22.5c9caca3.png";